import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { jobsAPI } from '@/utils/api';
import { toast } from 'sonner';
import { Calendar, User, Wrench } from 'lucide-react';

const Jobs = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadJobs = async () => {
      try {
        const data = await jobsAPI.getAll();
        setJobs(data);
      } catch (error) {
        toast.error('Failed to load jobs');
      } finally {
        setLoading(false);
      }
    };
    loadJobs();
  }, []);

  const getStatusColor = (status) => {
    const colors = {
      pending: 'bg-yellow-500',
      scheduled: 'bg-blue-500',
      in_progress: 'bg-orange-500',
      completed: 'bg-green-500',
      cancelled: 'bg-red-500'
    };
    return colors[status] || 'bg-gray-500';
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-white">Jobs</h1>
        <p className="text-gray-400 mt-1">Manage active and completed jobs</p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-gray-400">Loading jobs...</div>
      ) : jobs.length === 0 ? (
        <Card className="bg-gray-900/50 border-gray-800">
          <CardContent className="py-12 text-center text-gray-400">
            No jobs found. Enquiries will be converted to jobs when booked.
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {jobs.map((job) => (
            <Card key={job.job_id} className="bg-gray-900/50 border-gray-800 hover:border-amber-600/50 transition-colors">
              <CardHeader>
                <div className="flex items-center justify-between">
                  <CardTitle className="text-lg text-white">
                    {job.customer_name}
                  </CardTitle>
                  <Badge className={`${getStatusColor(job.status)} text-white`}>
                    {job.status}
                  </Badge>
                </div>
              </CardHeader>
              <CardContent className="space-y-3">
                <div className="flex items-center text-gray-300 text-sm">
                  <Wrench className="w-4 h-4 mr-2 text-amber-500" />
                  <span className="capitalize">{job.service_type?.replace('_', ' ')}</span>
                </div>
                {job.scheduled_date && (
                  <div className="flex items-center text-gray-300 text-sm">
                    <Calendar className="w-4 h-4 mr-2 text-amber-500" />
                    <span>{new Date(job.scheduled_date).toLocaleDateString()}</span>
                  </div>
                )}
                {job.assigned_engineer && (
                  <div className="flex items-center text-gray-300 text-sm">
                    <User className="w-4 h-4 mr-2 text-amber-500" />
                    <span>{job.assigned_engineer}</span>
                  </div>
                )}
                {job.notes && (
                  <p className="text-gray-400 text-sm mt-2 line-clamp-2">{job.notes}</p>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default Jobs;